import { useTheme } from "@mui/material";
import AccentDanger from "../../../icons/AccentDanger.svg?react";
import { OauthPopup } from "./OauthPopup";

const OauthInvalid = () => {
  const theme = useTheme();
  return (
    <OauthPopup
      Icon={
        <AccentDanger
          width="54px"
          height="54px"
          color={theme.palette.text10.main}
          fill={theme.palette.accentDanger30.main}
        />
      }
      outcome="Authentication failed, please try again."
      oauthId="oauth-success"
    />
  );
};

export { OauthInvalid };
